import { ChangeDetectionStrategy, Component, input} from '@angular/core';
import { AbstractFormComponent, FieldDateComponent, FieldNumberComponent, FieldTextComponent } from '@spike/scaffolds';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-isin-value-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonModule, FormsModule, FieldNumberComponent, FieldDateComponent],
  templateUrl: './isin-value-form.html'
})

export class IsinValueFormComponent extends AbstractFormComponent{

}
  

